import React from 'react';

/**
 * Borderless pill pagination, matching CLP's /admin/attendances pagination.
 */
const Pagination = ({ currentPage, totalPages, onPageChange }) => {
  if (!totalPages || totalPages <= 1) return null;

  return (
    <div className="mt-4 pt-4 border-top d-flex flex-column flex-md-row align-items-center justify-content-between gap-3">
      <p className="text-muted extra-small mb-0">
        Halaman <span className="fw-bold text-dark">{currentPage}</span> dari{' '}
        <span className="fw-bold text-dark">{totalPages}</span>
      </p>
      <nav aria-label="Page navigation">
        <ul className="pagination pagination-sm justify-content-center mb-0 gap-2">
          <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
            <button
              className="page-link rounded-pill border-0 bg-light text-dark px-3 fw-bold"
              disabled={currentPage === 1}
              onClick={() => onPageChange(currentPage - 1)}
            >
              <i className="bi bi-chevron-left"></i>
            </button>
          </li>
          <li className="page-item active">
            <span className="page-link rounded-pill border-0 bg-primary text-white px-3 fw-bold shadow-sm">
              {currentPage}
            </span>
          </li>
          <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
            <button
              className="page-link rounded-pill border-0 bg-light text-dark px-3 fw-bold"
              disabled={currentPage === totalPages}
              onClick={() => onPageChange(currentPage + 1)}
            >
              <i className="bi bi-chevron-right"></i>
            </button>
          </li>
        </ul>
      </nav>
    </div>
  );
};

export default Pagination;
